"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyKpiWithoutComparison = exports.isLegacyKpiWithComparison = exports.isLegacyKpi = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpi}.
 * @alpha
 */
function isLegacyKpi(obj) {
    return isLegacyKpiWithComparison(obj) || isLegacyKpiWithoutComparison(obj);
}
exports.isLegacyKpi = isLegacyKpi;
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpiWithComparison}.
 * @alpha
 */
function isLegacyKpiWithComparison(obj) {
    return (!isEmpty_1.default(obj) &&
        (obj.comparisonType === "previousPeriod" ||
            obj.comparisonType === "lastYear"));
}
exports.isLegacyKpiWithComparison = isLegacyKpiWithComparison;
/**
 * Type-guard testing whether the provided object is an instance of {@link ILegacyKpiWithoutComparison}.
 * @alpha
 */
function isLegacyKpiWithoutComparison(obj) {
    return !isEmpty_1.default(obj) && obj.comparisonType === "none";
}
exports.isLegacyKpiWithoutComparison = isLegacyKpiWithoutComparison;
//# sourceMappingURL=kpi.js.map